// extracted by mini-css-extract-plugin
export default {"headLines":"index_headLines_D7Y4c","newsItem":"index_newsItem_cwlBl"};